import React, { useContext, useRef } from 'react'
import { DatePicker, defaultDatePickerStrings } from '@fluentui/react';
import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap"
import CValidator from '../CValidator';
import MainAppContext from '../../../MainAppContext';
import moment from 'moment';

function CDatePicker(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);

    //Parametros de entrada.
    const inputParam_LabelText = props.labelText;
    const inputParam_ControlName = props.controlName;
    const inputParam_ControlValue = props.controlValue;
    const inputParam_SetterControlValue = props.setterControlValue;
    const inputParam_IsInvalirControl = props.isInValid;
    const inputParam_Disabled = props.disabled !== undefined && props.disabled !== null ? props.disabled : false;
    const inputParam_FormatDate = props.formatDate !== undefined && props.formatDate !== null ? props.formatDate : false;
    const inputParam_MinDate = props.minDate !== undefined && props.minDate !== null ? props.minDate : undefined;

    //Parametros de componente.

    const control = useRef(null);


    //Funciones de componente.

    const checkIfIsInvalidControl = () => {
        const _inputParam_IsInvalirControl = inputParam_IsInvalirControl !== null ? inputParam_IsInvalirControl : false;

        return _inputParam_IsInvalirControl === true ? true : false;
    }
    const setControlValue = (value) => { 
        inputParam_SetterControlValue && inputParam_SetterControlValue(value, control.current.id)
    }
    //Eventos de componente.

    const customCalendarStrings = {
        closeButtonAriaLabel: t('data-lang-lbl-close'),
        dayMarkedAriaLabel: t('data-lang-lbl-marked'),
        days: [
            t('data-lang-lbl-calendar-days-sunday'),
            t('data-lang-lbl-calendar-days-monday'),
            t('data-lang-lbl-calendar-days-tuesday'),
            t('data-lang-lbl-calendar-days-wednesday'),
            t('data-lang-lbl-calendar-days-thursday'),
            t('data-lang-lbl-calendar-days-friday'),
            t('data-lang-lbl-calendar-days-saturday')
        ],
        goToToday: t('data-lang-lbl-calendar-gototoday'),
        monthPickerHeaderAriaLabel: t('data-lang-lbl-calendar-changeyear'),
        months: [
            t('data-lang-lbl-calendar-month-january'),
            t('data-lang-lbl-calendar-month-february'),
            t('data-lang-lbl-calendar-month-march'),
            t('data-lang-lbl-calendar-month-april'),
            t('data-lang-lbl-calendar-month-may'),
            t('data-lang-lbl-calendar-month-june'),
            t('data-lang-lbl-calendar-month-july'),
            t('data-lang-lbl-calendar-month-august'),
            t('data-lang-lbl-calendar-month-september'),
            t('data-lang-lbl-calendar-month-october'),
            t('data-lang-lbl-calendar-month-november'),
            t('data-lang-lbl-calendar-month-december')
        ],
        nextMonthAriaLabel: t('data-lang-lbl-calendar-nextmonth'),
        nextYearAriaLabel: t('data-lang-lbl-calendar-nextyear'),
        nextYearRangeAriaLabel: t('data-lang-lbl-calendar-nextyearrange'),
        prevMonthAriaLabel: t('data-lang-lbl-calendar-previousmonth'),
        prevYearAriaLabel: t('data-lang-lbl-calendar-previousyear'),
        prevYearRangeAriaLabel: t('data-lang-lbl-calendar-previousyearrange'),
        selectedDateFormatString: t('data-lang-lbl-calendar-selecteddate'),
        shortDays: [
            t('data-lang-lbl-calendar-shortdays-sunday'),
            t('data-lang-lbl-calendar-shortdays-monday'),
            t('data-lang-lbl-calendar-shortdays-tuesday'),
            t('data-lang-lbl-calendar-shortdays-wednesday'),
            t('data-lang-lbl-calendar-shortdays-thursday'),
            t('data-lang-lbl-calendar-shortdays-friday'),
            t('data-lang-lbl-calendar-shortdays-saturday')
        ],
        shortMonths: [
            t('data-lang-lbl-calendar-shortmonth-january'),
            t('data-lang-lbl-calendar-shortmonth-february'),
            t('data-lang-lbl-calendar-shortmonth-march'),
            t('data-lang-lbl-calendar-shortmonth-april'),
            t('data-lang-lbl-calendar-shortmonth-may'),
            t('data-lang-lbl-calendar-shortmonth-june'),
            t('data-lang-lbl-calendar-shortmonth-july'),
            t('data-lang-lbl-calendar-shortmonth-august'),
            t('data-lang-lbl-calendar-shortmonth-september'),
            t('data-lang-lbl-calendar-shortmonth-october'),
            t('data-lang-lbl-calendar-shortmonth-november'),
            t('data-lang-lbl-calendar-shortmonth-december')
        ],
        todayDateFormatString: t('data-lang-lbl-calendar-todaysdate'),
        weekNumberFormatString: t('data-lang-lbl-calendar-weeknumber'),
        yearPickerHeaderAriaLabel: t('data-lang-lbl-calendar-changemonth'),
    }

    const formatDate = (date) => {
        const formattedDate = date ? moment(date, 'DD/MM/YYYY', 'es', true).format('DD/MM/YYYY') : '';
        return formattedDate;
    }

    //Render de componente.
    return (
        <>
            {
                inputParam_LabelText &&
                <b><Form.Label>{ inputParam_LabelText }</Form.Label></b>
            }
            <DatePicker
                id={ inputParam_ControlName }
                disabled={inputParam_Disabled}
                ref={ control }
                firstDayOfWeek={ 1 }
                showWeekNumbers={ true }
                firstWeekOfYear={ 1 }
                showMonthPickerAsOverlay={ true }
                placeholder={ t('data-lang-lbl-selectdate') }
                // DatePicker uses English strings by default. For localized apps, you must override this prop.
                strings={ customCalendarStrings }
                onSelectDate={ setControlValue }
                value={ inputParam_ControlValue !== null && inputParam_ControlValue !== undefined ? new Date(inputParam_ControlValue) : null }
                isInvalid={ checkIfIsInvalidControl() }
                formatDate={inputParam_FormatDate ? inputParam_FormatDate : formatDate}
                minDate={inputParam_MinDate}
            />
            <CValidator isInValid={ checkIfIsInvalidControl() } />
        </>
    );
}

export default CDatePicker;